// extracted by mini-css-extract-plugin
export default {"HomePhoto":"HomePhoto_HomePhoto__hnPvj","HomePhotoScrolling":"HomePhoto_HomePhotoScrolling__dvsGc","ScrollingIcon":"HomePhoto_ScrollingIcon__B+nM9"};